module.exports = "pegasus/assets/blocks/column-13-theme5.png";